<template>
    <div v-if="!loading">
        <div v-if="hasFreeMessages" class="kmn-usage-progess">
            <h6 class="usage-title">
                Text message usage
            </h6>
            <div class="free-messages">
                <ds-icon name="message" class="message-icon" /> <span>{{ freeTxtMsg }}</span>
            </div>

            <ds-progress-bar
                class="message-progress-bar"
                :progress="messageCount"
                :max="textLimit"
                :label=" `${messageCount}/${textLimit} ${limitMsg}`"
                hide-label-value
            />
        </div>

        <div v-if="!hasFreeMessages" class="kmn-usage-progess">
            <h6 class="usage-title">
                Text message usage
            </h6>
            <div class="usage-spent-container">
                <div class="usage-spent">
                    Total spent this billing cycle
                </div>
            </div>

            <div>
                <div class="total-spent">
                    ${{ totalSpent }}
                </div>
                <div>
                    <div class="message-counts">
                        Total included text messages sent: {{ textLimit }}
                    </div>
                    <div class="message-counts">
                        Total additional text messages sent: {{ paidMessages }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

const PRICE_PER_MESSAGE = 0.015;

export default {
    name: 'TextMessageUsage',

    data() {
        return {
            textLimit: 250,
            messageCount: 0,
            loading: false,
            PRICE_PER_MESSAGE,
            limitMsg: '',
            freeTxtMsg: '',
        };
    },

    created() {
        if (window.keapI18nMap !== undefined) {
            this.limitMsg = window.keapI18nMap['funnel.campaign.communications.marketpopup.numnav.limitmsg'];
            this.freeTxtMsg = window.keapI18nMap['funnel.campaign.communications.marketpopup.numnav.freetxtmsg'];
        } else {
            this.limitMsg = 'text messages used';
            this.freeTxtMsg = 'Included text messages (per billing cycle)';
        }
    },


    mounted() {
        this.load();
    },

    computed: {
        totalSpent() {
            return (this.paidMessages * PRICE_PER_MESSAGE).toFixed(3);
        },

        paidMessages() {
            return (this.messageCount <= this.textLimit) ? 0 : (this.messageCount - this.textLimit);
        },

        hasFreeMessages() {
            return this.messageCount <= this.textLimit;
        },
    },

    methods: {
        async load() {
            this.loading = true;
            const { data } = await axios.get('/app/automatedSmsFunnel/getSMSUsageBillingCycle');

            this.messageCount = data.messageCount;
            this.textLimit = data.limit;
            this.loading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
    .info-icon {
        --icon-size: #{$icon-size-small};
        height: 0.5rem;
        width: 0.5rem;
        margin: 0.66rem 0 0 $spacing-050;
    }

    .usage-title {
        font-weight: $font-weight-bold;
        text-transform: none;
    }

    .usage-info-tooltip-content {
        padding: $spacing-200;
    }

    .kmn-usage-progess {
        margin-top: $spacing-200;

        .message-progress-bar {
            width: 50%;
        }
    }

    .usage-spent {
        font-size: $font-size-sm;
        font-weight: bold;
        margin-top: $spacing-100;
    }

    .message-counts {
        margin-top: $spacing-050;
    }

    .usage-spent-container {
        display: flex;
        align-items: center;
    }

    .total-spent {
        font-size: $font-size-lg;
        font-family: monospace;
        margin-bottom: $spacing-200;
    }

    .free-messages {
        display: flex;
        align-items: center;
        margin: $spacing-100 0;
    }

    .message-icon {
        margin-right: $spacing-100;
    }

</style>
